import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  public static logContext(context: any, error?: any) {
    const className = context.constructor ? context.constructor.name : 'UnknownClass';
    const methodName = context.logContext ? context.logContext.name : 'UnknownMethod';

    console.group(`DEBUG Context : ${document.location.href} ${className}.${methodName}`);

    if (error) {
      if (error.stack == undefined && error.message == undefined) console.error('Stack Trace:', error);
      else if (error?.stack != undefined) console.error('Stack Trace:', error?.stack);
      else if (error?.message != undefined) console.error('Error Message:', error?.message);
    }

    console.log('Context Object:', context);

    console.groupEnd();
  }
}
